import { render, staticRenderFns } from "./RenounceSavingRequested.vue?vue&type=template&id=02fca96b&scoped=true&"
import script from "./RenounceSavingRequested.vue?vue&type=script&lang=js&"
export * from "./RenounceSavingRequested.vue?vue&type=script&lang=js&"
import style0 from "./RenounceSavingRequested.vue?vue&type=style&index=0&id=02fca96b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fca96b",
  null
  
)

export default component.exports